// extracted by mini-css-extract-plugin
export default {"indentMargin":"IndentMain_indentMargin__skZNq","restricted-link":"IndentMain_restricted-link__3uCAl"};